import Label from 'components/Label';
import TextWithIcon from 'components/TextWithIcon';
import { ROUTES } from 'constants/routes';
import { Link } from 'react-router-dom';

const NewsCard = ({ data }) => {
    const { title_background, title, type, slug } = data;
    const size = false;
    return (
        <Link to={ROUTES.news + '/' + slug} className={`news-card ${size ? 'news-card--big' : ''}`}>
            <div className="news-card__image">
                <img src={title_background} alt="news" />
            </div>
            <div className="news-card__content">
                <div className="news-card-labels">
                    <Label>{type}</Label>
                </div>
                <div className="news-card__title description-demibold">{title}</div>
                <div className="news-card-date">
                    <TextWithIcon iconName="calendar" text={'!!add date'} />
                    <TextWithIcon iconName="clock" text={'!!add time to read'} />
                </div>
            </div>
        </Link>
    );
};

export default NewsCard;
